import { Table } from '@common/data-models/complex-types/table';

export class Relationship extends Table {

    constructor() {
        super();
    }

    public getGuid(i: number): string {
        return this.get(i, 0);
    }

    public setGuid(guid: string, i: number) {
        this.set(i, 0, guid);
    }

    public getType(i: number): string {
        return this.get(i, 1);
    }

    public setType(type: string, i: number) {
        this.set(i, 1, type);
    }

    public removeByGuid(guid: string) {
        let rowToRemoveIndex = null;
        for (let i = 0; i < this.data.length; i++) {
            if (this.data[i][0] == guid) rowToRemoveIndex = i;
        }
        if (rowToRemoveIndex != null) this.data.splice(rowToRemoveIndex, 1);
    }

    public addRelationship(guid, type) {
        const index = this.getRowCount();
        this.set(index, 0, guid);
        this.set(index, 1, type);
    }

    public equals(target: Relationship): boolean {
        if (!target) {
            return (this.data.length == 0);
        }
        if(this.data.length != target.data.length) return false;

        return true;
    }
}
